<template>
  <modal
    :nextRoute="{name: 'menuIndex',params: { userSlug: rawMenu.user.slug }}"
    :showCloseButton="true"
  >
    <div
      class="text-center "
      slot="heading"
    >
      <h1 class=" mb-0">
        <span
          v-if="!rawMenu.user.sms_marketing_form_heading"
          class="font-weight-bold"
        >Deals</span>
        <span
          v-else
          class="font-weight-bold small"
        >{{rawMenu.user.sms_marketing_form_heading}}</span>
      </h1>
      <p
        class="small mb-0"
        style="font-size:1rem"
        v-if="!success"
      >
        <span v-if="!rawMenu.user.sms_marketing_form_description"> Subscribe to get {{rawMenu.user.name}}'s Deals, Vouchers & Coupons sent to your phone. We will only send you genuine savings, unsubscribe anytime.</span>
        <span v-else>{{rawMenu.user.sms_marketing_form_description}}</span>
      </p>
    </div>
    <div
      slot="content"
      class="px-3"
    >
      <div v-if="success"><span v-if="!rawMenu.user.sms_marketing_form_success_text">Thank you for subscribing. You will be the first to know when we have any discounts available.</span>
        <span v-else>{{rawMenu.user.sms_marketing_form_success_text}}</span>
      </div>
      <form
        v-on:submit.prevent="onSubmit"
        v-if="!success"
      >
        <div class="form-group">
          <label for="name">First name</label>
          <input
            v-model="name"
            type="text"
            class="form-control"
            id="name"
            v-bind:class="{ 'is-invalid': errors.name }"
            required
          />
          <small
            v-if="errors.name"
            class="text-danger"
          >{{ errors.name}}</small>
        </div>

        <div class="form-group">
          <label for="phone">Mobile number</label>
          <input
            v-model="phone"
            type="number"
            class="form-control"
            id="phone"
            v-bind:class="{ 'is-invalid': errors.phone }"
          />
          <small
            v-if="errors.phone"
            class="text-danger"
          >{{
                            errors.phone
                        }}</small>
        </div>

        <button
          type="submit"
          class="btn btn-primary btn-lg btn-block mt-4"
          v-if="!appProcessing"
        >
          Subscribe
        </button>
        <formLoader
          v-if="appProcessing"
          class="text-center my-5"
        ></formLoader>
        <div
          v-if="!appProcessing"
          class="small text-center mt-3"
        >
        </div>

      </form>
    </div>
  </modal>
</template>

<style scoped>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  appearance: textfield;
}
</style>

<script>
import formLoader from "../../form/FormLoader";
import modal from "../../shared/Modal";
import pageMixin from "../../../mixins/pageMixin";
import formMixin from "../../../mixins/formMixin";
export default {
  mounted() {
    this.$gtag.pageview({
      page_title:
        "Subscribe to get " +
        this.rawMenu.user.name +
        "'s Deals, Vouchers & Coupons",
    });
  },
  data() {
    return {
      name: "",
      phone: "",
      success: false,
    };
  },
  metaInfo() {
    return {
      title:
        "Subscribe to get " +
        this.rawMenu.user.name +
        "'s Deals, Vouchers & Coupons",
      vmid: "title",
      meta: [
        {
          name: "description",
          vmid: "description",
          content:
            "Subscribe to get " +
            this.rawMenu.user.name +
            "'s Deals, Vouchers & Coupons",
        },
        {
          name: "og:title",
          vmid: "ogTitle",
          content:
            "Subscribe to get " +
            this.rawMenu.user.name +
            "'s Deals, Vouchers & Coupons",
        },
        {
          name: "og:description",
          vmid: "ogDescription",
          content:
            "Subscribe to get " +
            this.rawMenu.user.name +
            "'s Deals, Vouchers & Coupons",
        },
      ],
    };
  },
  methods: {
    onSubmit: function () {
      this.setAppProcessing(true);
      this.errors = {};
      axios
        .post("/api/user/subscribe", {
          user_id: this.rawMenu.user.id,
          name: this.name,
          phone: parseInt(this.phone),
          phone_country: this.rawMenu.user.country.iso,
        })
        .then(
          (response) => {
            this.setAppProcessing(false);
            this.success = true;
          },
          (error) => {
            this.setAppProcessing(false);
            if (error.response.data.errors) {
              this.errors = error.response.data.errors;
            } else {
              this.errors.phone =
                "Please enter a valid " +
                this.rawMenu.user.country.name +
                " mobile phone number";
            }
          }
        );
    },
  },
  components: {
    formLoader,
    modal,
  },
  mixins: [pageMixin, formMixin],
};
</script>
